import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Divider from "../../components/layout/Divider";
import Modal from "../../components/Modal";
import { Roles } from "../../components/roles";

function BookingSuccessful(props: any) {
  const { t } = useTranslation(); // i18n

  let value = ('; ' + document.cookie).split(`; maxTime=`).pop()?.split(';')[0];

  let url = document.URL;

  return (
    <Container className="pt-5">
      <Row>
        <Col xs={{ span: 10, offset: 1 }}>
          <Modal>
            <h1 className="text-center p-1">{t("bookingSuccessful.title")}</h1>
            <Divider />
            <div className="text-center m-4">
              <FontAwesomeIcon
                size="6x"
                className="text-primary"
                icon={faCheckCircle}
              />
            </div>
            <div className="bg-light border p-2 mlr-4 text-center">
              <h2 className="m-2">
                {t("bookingSuccessful.boxImportantTitle")}
              </h2>
              <h4>{t("bookingSuccessful.boxImportantText")}</h4>
              <h4>{t("bookingSuccessful.latestCheckoutTime", { val: value })}</h4>
            </div>
            <div className="mt-2 p-2 mlr-4 text-center">
              <Link to={url.includes("terminal") ? "/terminal" : "/checkout"}>
                <Button
                  variant="secondary"
                  className="w-80 mb-2 border mx-auto"
                >
                  {url.includes("terminal") ? t("bookingSuccessful.backToTerminal") : t("bookingSuccessful.wantToSignOut")}
                </Button>
              </Link>
            </div>
          </Modal>
        </Col>
      </Row>
    </Container>
  );
}

export default BookingSuccessful;
